<template>
  <div id="france-card">
    <!-- Modal Header -->
    <div class="modal-header-card">
      <h2 class="modal-title">Carte de nos hébergements en France</h2>
      <button class="modal-close cursor-pointer" @click="$emit('close')" aria-label="Close">
        <span>&times;</span>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="row">
        <!-- Left: Map -->
        <div class="col-lg-6 col-12">
          <France @goToCard='redirectToCard' :destination='destinations[0]' @regionHovered='onRegionHovered($event)' v-if='destinations'></France>
        </div>

        <!-- Right: Content -->
        <div class="col-lg-6 col-12">
          <!-- Featured Image -->
          <div class="featured-image" v-if="regionComputed && (regionComputed.photo || regionComputed.photo_key)">
            <img :src="regionComputed.photo_key || regionComputed.photo" :alt="regionComputed.name" />
          </div>

          <div class="text-section d-flex flex-column gap-3">
            <div class="info-header">
              <h3 class="raleway-bold-p15 text-uppercase" @click="redirectToUrl('/destination/' + regionComputed.slug)">{{ regionComputed.name || 'FRANCE' }}</h3>
              <span class="lodging-count raleway-medi-p15" v-if="lodgingCount > 0">{{ lodgingCount }} HÉBERGEMENTS</span>
            </div>

            <!-- Description -->
            <p class="description raleway-reg-p15" v-if="regionComputed.content">
              {{ regionComputed.content }}
            </p>

            <!-- CTA Button -->
            <div class="button-container">
              <a :href="`/destination/${regionComputed.slug}`" class="hortense-btn-primary btn-discover">
                Découvrir notre sélection
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import France from 'components/destinations/France.vue';
  import CardRegion from 'components/cards/CardRegion.vue';
  import AOS from 'aos';

  export default {
    name: 'france-card',
    components: {  France, CardRegion },
    props: {
      destinations: Array
    },
    data() {
      return {
        lodgingsCount: 0,
        selectedRegion: null,
        isPhone: window.innerWidth <= 768
      }
    },
    methods: {
      onRegionHovered(name) {
        const mapName =  name.includes('Provence-Alpes-Côte') ? 'Provence-Alpes-Côte D’Azur' : name;
        this.selectedRegion = this.destinations?.[0]?.regions.find(region => region.name === mapName);
      },
      redirectToCard(name) {
        if (this.isPhone) {
          return;
        }
        const map = {
          'ô': 'o',
          'é': 'e',
          'è': 'e',
          'ê': 'e',
          'à': 'a',
          'ù': 'u',
          'ç': 'c'
        };

        const formattedName = name
            .toLowerCase()
            .replace(/[^\w\s-]/g, function(match) {
              return map[match] || match;
            })
            .replace(/\s+/g, '-');

        window.open(`/destination/${formattedName}`, '_blank');
      },
      scrollToMe(name) {
        const elementFound = this.$children.find(e => e.$el.id === name);
        const topEl = elementFound.$el.offsetTop;

        window.scrollTo(0, topEl);
      },
      redirectToUrl(url) {
        window.open(url, '_blank');
      }
    },
    mounted(){
      AOS.init();
    },
    computed: {
      lodgingCount() {
        if (this.regionComputed && this.regionComputed?.get_lodgings) {
          return this.regionComputed.get_lodgings.length;
        } else {
          this.destinations.forEach((destination) => {
            const lodging = destination.get_lodgings.length
            this.lodgingsCount += lodging
          })
          return this.lodgingsCount
        }
      },
      regionComputed() {
        return this.selectedRegion || this.destinations[0]
      }
    }
  }
</script>
<style scoped lang="scss">
#france-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modal-header-card {
  background-color: #3B6152;
  color: white;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}

.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 32px;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
}

.modal-close:hover {
  opacity: 0.8;
}

.modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 40px;
  background-color: #f9f9f9;
  
  @media screen and (max-width: 768px) {
    max-height: 90vh;
  }
}

.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  max-width: 1400px;
  margin: 0 auto;
  align-items: start;
}

.map-section {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 500px;
}

.map-section svg {
  width: 100%;
  height: auto;
  max-width: 500px;
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 25px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
}

.featured-image {
  width: 100%;
  height: 300px;
  overflow: hidden;
  border-radius: 4px;
}

.featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 20px;
}

.region-title {
  margin: 0;
  color: #1a1a1a;
  letter-spacing: 0.5px;
}

.lodging-count {
  color: #3B6152;
  font-style: italic;
  white-space: nowrap;
}

.description {
  margin: 0;
  line-height: 1.6;
  color: #000;
  text-align: justify;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* Tablet Design */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .modal-content {
    padding: 30px;
  }

  .map-section {
    min-height: 400px;
  }

  .featured-image {
    height: 250px;
  }

  .region-title {
    font-size: 20px;
  }
}

/* Mobile Design */
@media (max-width: 768px) {
  .modal-header-card {
    padding: 15px 20px;
  }

  .modal-title {
    font-size: 16px;
  }

  .modal-content {
    padding: 20px;
  }

  .content-wrapper {
    gap: 25px;
  }

  .map-section {
    min-height: 300px;
  }

  .featured-image {
    height: 200px;
  }

  .info-header {
    margin-bottom: 10px;;
  }

  .region-title {
    font-size: 18px;
  }

  .description {
    font-size: 14px;
  }

  .button-container {
    justify-content: center;
  }

  .btn-discover {
    width: 100%;
    text-align: center;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .modal-header-card {
    padding: 12px 15px;
  }

  .modal-title {
    font-size: 14px;
  }

  .modal-content {
    padding: 15px;
  }

  .map-section {
    min-height: 250px;
  }

  .featured-image {
    height: 180px;
  }

  .region-title {
    font-size: 16px;
  }

  .description {
    font-size: 13px;
  }
}

.text-section {
  padding: 30px;
  min-height: 305px;
  @media screen and (max-width: 768px) {
    padding: 10px;
    min-height: unset;
  }
}
</style>
